<template>
  <div>
    <mdb-row v-if="user._id">
      <mdb-col class="mx-auto" md="8">
        <mdb-card class="px-4">
          <mdb-card-body>
            <mdb-card-title><mdb-icon  icon="user-plus" /> 회원 정보 수정</mdb-card-title>
            <mdb-card-text>
              <form>
                <mdb-input class="mb-1 w-50" label="사용자 ID" :value="user.userId" disabled/>
                <mdb-input label="이름*"  class="w-50" v-model="user.name" />
                <mdb-input label="email*"  class="w-60" type="email" v-model="user.email"/>
                <mdb-input label="전화번호(010-xxxx-xxxx)"   class="w-60" v-model="cellphone"/>
                <div> 성별:
                  <label><input type="radio" v-model="user.gender" value="남"> 남</label>
                  <label class="ml-3"><input type="radio" v-model="user.gender" value="여"> 여</label>
                </div>
                <div>훈련 선택:
                  <select v-model="user.status" class="input-underline">
                    <option v-for="(t,x) in ['훈련중', '중도포기', '조기취업', '수료', '미수료']" :key="x"
                      :value="t">{{t}}</option>
                  </select>
                </div>
                <mdb-input label="주소" v-model="user.address"/>
                <div class="text-center">
                  <mdb-btn icon="check" @click="onUpdateUser">확인</mdb-btn>
                  <mdb-btn icon="undo" @click="$router.back()">돌아가기</mdb-btn>
                </div>
              </form>
            </mdb-card-text>
          </mdb-card-body>
        </mdb-card>
      </mdb-col>
    </mdb-row>
  </div>
</template>
<script>
import { mdbCard, mdbCardBody, mdbCardTitle, mdbCardText } from 'mdbvue';
import { mapState } from 'vuex';
export default {
  name: 'StaffStudentEditPage',
  components: { mdbCard, mdbCardBody, mdbCardTitle, mdbCardText },
  data: function () {
    return {
      user: {},
      cellphone: ''
    }
  },
  computed: {
    ...mapState('auth', ['org']),
    ...mapState('training', ['training']),
    userId () { return this.user.userId }
  },
  methods: {
    async onUpdateUser () {
      if (this.cellphone !== '') {
        const nums = this.cellphone.split('-')
        if (nums.length !== 3) {
          alert('전화번호 형식이 틀렸습니다.')
          return
        }
        this.user.cellPhone = {
          number1: nums[0],
          number2: nums[1],
          number3: nums[2]
        }
      }
      if (!confirm('저장할까요?')) {
        return;
      }
      this.user.org = this.org._id
      await this.user.save(this.user)
      this.$router.back()
    },
    async load () {
      this.user = await this.$member.get(this.$route.query.student)
      if (this.user.cellPhone) {
        this.cellphone = this.user.cellPhone.number1 + '-' + this.user.cellPhone.number2 + '-' + this.user.cellPhone.number3
      }
    }
  },
  async created () { this.load() }
}
</script>
